module.exports = __webpack_public_path__ + "img/take_away_map.8d7295c8.svg";